module.exports = __webpack_public_path__ + "static/media/analysis.d0716617.png";